define("shared/components/shared/upgrade/details-list", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <ul data-test-id="highlight-list" class="tCH--list qa--checkout__featureList u--m__b__0">
    {{#each @plan.highlights as |highlight|}}
      <li class="tCH--list__li">{{if highlight.copy highlight.copy highlight}}</li>
    {{/each}}
  </ul>
  */
  {
    "id": "LQp3XAJB",
    "block": "[[[10,\"ul\"],[14,\"data-test-id\",\"highlight-list\"],[14,0,\"tCH--list qa--checkout__featureList u--m__b__0\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,1,[\"highlights\"]]],null]],null],null,[[[1,\"    \"],[10,\"li\"],[14,0,\"tCH--list__li\"],[12],[1,[52,[30,2,[\"copy\"]],[30,2,[\"copy\"]],[30,2]]],[13],[1,\"\\n\"]],[2]],null],[13]],[\"@plan\",\"highlight\"],false,[\"each\",\"-track-array\",\"if\"]]",
    "moduleName": "shared/components/shared/upgrade/details-list.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});